import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { IFieldProps } from '../models/IFieldProps'

export const getFieldName = ({
  actualsType,
  isUnits,
  currency,
  sType,
  isSoB,
  isDirect,

  isComposedCompletedPlans,
  isCompleteSob,
}: IFieldProps): string => {
  //
  // TODO: How about 't' for Transactional? Process at parent level?
  //
  const contrStr = sType === 'c' ? 'Contractual' : ''
  // In future we can use other sell types: SellIn, SellOut, SellTo
  const isShipment = false // Deprecated
  let saleStr = isShipment ? 'Shipment' : 'SellThru'
  if (sType) {
    saleStr = ''
  }
  const unitStr = isUnits ? 'Units' : 'Sum'
  const isUSD = !currency || currency === 'USD'
  let currStr = isUSD ? 'USD' : 'LC'
  let actualTypeStr = actualsType
  if (isUnits) {
    currStr = ''
    if (actualsType === ActualsValueTypes.Net) {
      actualTypeStr = ActualsValueTypes.None
    }
  }
  let fieldName = `${contrStr}${saleStr}${unitStr}${currStr}${actualTypeStr}`
  if (isSoB) {
    fieldName = 'SoB'
  }

  if (isComposedCompletedPlans) {
    fieldName = `${fieldName}Completed`
  }
  if (isCompleteSob && !isSoB) {
    fieldName = `${fieldName}Sob`
  }

  if (isDirect && !isSoB) {
    fieldName = `${fieldName}Direct`
  }

  return fieldName
}
